import { Badge } from "@/shared/ui/badge";
import type { ListItem } from "../types";
import { EvidenceBadge } from "../EvidenceBadge";

interface SectionListProps {
  title: string;
  items: ListItem[];
}

export function SectionList({ items }: SectionListProps) {
  return (
    <ul className="divide-y divide-border">
      {items.map((item, i) => (
        <li key={i} className="flex items-start justify-between gap-4 px-5 py-3">
          <div className="min-w-0 flex-1">
            <div className="text-sm text-foreground truncate">{item.primary}</div>
            {item.secondary ? (
              <div className="text-xs text-muted-foreground mt-0.5">{item.secondary}</div>
            ) : null}
          </div>
          <div className="flex items-center gap-2 shrink-0">
            {item.evidence_urls && item.evidence_urls.length > 0 ? (
              <EvidenceBadge
                urls={item.evidence_urls}
                caption={{ leaf: item.primary }}
                size="sm"
              />
            ) : null}
            {item.badge ? (
              <Badge variant="outline">{item.badge}</Badge>
            ) : null}
          </div>
        </li>
      ))}
    </ul>
  );
}
